import React, { useContext, useMemo } from 'react';

import { useUserDetails, useUserPermissions } from './data';
import { ContextUserStruct, IDebugProvider } from './interfaced';

export const useUser = () => {
  return useContext(UserContext);
};

export const UserContext = React.createContext({} as ContextUserStruct);

export const UserProvider = ({ children }: IDebugProvider) => {
  const { data: user } = useUserDetails();
  const { data: permissions } = useUserPermissions();

  const isDevUser = useMemo(
    () =>
      user &&
      (user.userPosition.includes('Developer') ||
        user.userPosition.includes('QA')),
    [user]
  );

  return (
    <UserContext.Provider
      value={{
        user,
        permissions,
        isDevUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
